import {Moment} from 'moment-timezone'

import {useUpmPlantNow} from './useUpmPlantNow'
import {useUpmPlantTimezone} from './useUpmPlantTimezone'

/// Hook to get the start of today in the UPMs plant's timezone
export const usePlantStartOfToday = (): Moment => {
  const getPlantNow = useUpmPlantNow()
  const timezoneId = useUpmPlantTimezone()
  return getPlantNow().clone().tz(timezoneId).startOf('day')
}
